<template>
  <v-layout row wrap v-if="!isStoreLoading" id="StorePage" class="sticky-parent">
    <PopupModal v-if="shouldShowModal" :imagePth="imagePath" :loading="imgLoading" />
    <PopupModal v-if="shouldShowReferralModal" :imagePth="imageReferralPath" :loading="imgLoading" />
    <call-server-dialog v-if="isDineIn" />
    <store-sub-header />

    <h1 v-if="!isMenuChannelAllowed()" class="fullWidth" style="margin-top: 20px; text-align: center">
      Sorry, this menu is not available online
    </h1>
    <template v-else>
      <v-flex 
        v-if="!shouldUseCustomHeader && !!getMenuItemsAndGroups && getMenuItemsAndGroups.length > 1" 
        class="sticky" 
        :style="{ top: (stickyMenuOffset - 1) + 'px' }" 
        row 
        xs12
      >
        <div id="menuText" :class="{ 'text-mobile': $vuetify.breakpoint.mdAndDown }">
          {{ $vuetify.t('$vuetify.menu.menuTitle') }}
        </div>
        <menu-category :menus="categoriesWithAiRecommendations" ref="MenuCategory" />
      </v-flex>
      <v-flex 
        v-if="shouldUseCustomHeader && !!getMenuItemsAndGroups && getMenuItemsAndGroups.length > 1" 
      >
        <menu-category-custom :menus="categoriesWithAiRecommendations" ref="MenuCategoryCustom" />
        <!-- <div class="menuHeader">
          <h5 class="menuHeaderText">
            SMALL $12.99 | MEDIUM $15.99 | LARGE $19.99 | X-LARGE $23.99 | Party Size (15 X 21) $29.99
          </h5>
        </div> -->
      </v-flex>
      <v-flex v-if="filteredCategories && filteredCategories.length" row xs12 class="marginsDesktop">
        <div v-for="(item, index) in categoriesWithAiRecommendations" :id="item.anchor" class="menuContainer">
          <v-subheader :id="item.code" :key="`menu_${index}`" :class="['subheader', { 'custom-header': shouldUseCustomHeader }]">
            {{ item.name }}
          </v-subheader>

          <div v-if="item.description" v-html="item.description" :class="['categoryDescription', { 'custom-header': shouldUseCustomHeader }]"> </div>

          {{ item.schedule }}

              <v-layout row wrap grid-list-md :style="shouldUseCustomHeader ? 'justify-content: center !important;' : ''">
              <template v-for="i in item.items" v-if="'code' in i">
                <!-- Custom header: 4 per row -->
                <v-flex
                  v-if="shouldUseCustomHeader"
                  :key="`${i.code}-list-custom`"
                  xs12 sm3 md3 lg3 xl3
                  class="pa-1 vertical-card"
                  :style="$vuetify.breakpoint.mdAndDown ? 'min-height: 110px !important' : 'min-height: 150px !important'"
                >
                  <menu-item-card-custom
                    :id="i.code"
                    :key="`menu_${index}${i.code}`"
                    :menuItem="i"
                    :listView="true"
                  />
                </v-flex>

                <!-- Non-custom header: 3 per row (original) -->
                <v-flex
                  v-else-if="!shouldUseCustomHeader && showAsList(item)"
                  :key="`${i.code}-list`"
                  xs12 sm6 md4 xl3
                  class="pa-1"
                  :style="$vuetify.breakpoint.mdAndDown ? 'min-height: 110px !important' : 'min-height: 150px !important'"
                >
                  <menu-item-card
                    :id="i.code"
                    :key="`menu_${index}${i.code}`"
                    :menuItem="i"
                    :listView="true"
                  />
                </v-flex>
                <!-- Card view for non-custom header -->
                <v-flex
                  v-else
                  :key="`${i.code}-card`"
                  xs12 sm6 md4 xl3
                  class="pa-1"
                  :style="$vuetify.breakpoint.mdAndDown ? 'min-height: 50px !important' : 'min-height: 50px !important'"
                >
                  <menu-item-card
                    :key="`menu_${index}${i.code}`"
                    :menuItem="i"
                    :listView="false"
                  />
                </v-flex>
              </template>
          </v-layout>
        </div>
      </v-flex>
      <v-flex v-if="menuDisclaimer && filteredCategories && filteredCategories.length" xs12>
        <v-divider />
        <p class="menu-disclaimer">{{ menuDisclaimer }}</p>
      </v-flex>
      <v-flex v-if="!(filteredCategories && filteredCategories.length)" row xs10 id="NoResultsFound" :style="$vuetify.breakpoint.mdAndUp ? 'max-width: 300px;' : null ">
        <h2 style="margin: 20px auto 0px">
          {{ $vuetify.t('$vuetify.storePage.error.empty') }}
        </h2>

        <br>

        <v-img
          src="/owa/img/other/noResults.jpg"
          height="200"
          contain
        />

        <template v-if="!!searchText">
          <h4 style="margin: 10px auto 20px">
            '{{ searchText }}' {{ $vuetify.t('$vuetify.storePage.error.noResults') }} <br>

            {{ $vuetify.t('$vuetify.storePage.error.tryAdjusting') }}
            <br><br>
            {{ $vuetify.t('$vuetify.common.or') }}
          </h4>

          <v-btn color="primary" class="fullWidth noMargin" @click="clearSearch()">
            {{ $vuetify.t('$vuetify.storePage.error.clear') }}
          </v-btn>
        </template>
      </v-flex>
    </template>
  </v-layout>
</template>

<script>
import get from 'lodash/get';

// Module-level flag so multiple StorePage mounts don't each trigger auto-open
let _autoOpenFired = false

import { mapGetters, mapActions } from 'vuex'
import { generateMenuAnchorId, enableDocumentScrolling, checkAndSetModalVisibility, buildScheduledTargetDate, matchTranslation, resolveMenuItemId, slugifyMenuItemName } from "@/services/util.service"
import { compareSchedules, getItemScheduleItems } from "@/services/schedule.service"
import { EventBus } from "@/services/event-bus"

import MenuItemCard from '@/components/MenuItem/menuItemCard.vue';
import CallServerDialog from "@/components/Dialogs/CallSeverDialog"
import CouponCard from "@/components/Coupons/CouponCard"
import PromotionRewardsCard from "@/components/PromotionRewards/PromotionRewardsCard"
import PunchCard from "@/components/Common/PunchCard"
import StoreSubHeader from '@/components/StoreSubHeader.vue'
import MenuCategory from '@/components/MenuCategory.vue'
import OrderTypeSelect from '@/components/OrderTypeSelect'
import Cart from '@/components/Cart.vue'
import PopupModal from '@/views/PopupModal.vue'
import RewardOptionsCard from "@/components/RewardsOptions/RewardOptionsCard"
import ReferralCard from '@/components/RewardsOptions/ReferralCard.vue'
import { isInSchedule } from "@/services/schedule.service"
import MenuCategoryCustom from '../components/MenuCategoryCustom.vue';
import MenuItemCardCustom from '../components/MenuItem/menuItemCardCustom.vue';
import PunchCardDetail from '../components/Common/PunchCardDetail.vue';
import RewardOptionsCardDetail from '../components/RewardsOptions/RewardOptionsCardDetail.vue';
import CouponCardDetail from '../components/Coupons/CouponCardDetail.vue';
export default {
  components: {
    MenuItemCard,
    MenuItemCardCustom,
    CallServerDialog,
    CouponCard,
    CouponCardDetail,
    StoreSubHeader,
    MenuCategory,
    MenuCategoryCustom,
    OrderTypeSelect,
    Cart,
    PopupModal,
    PunchCard,
    PunchCardDetail,
    RewardOptionsCardDetail,
    PromotionRewardsCard,
    RewardOptionsCard,
    ReferralCard
  },

data() {
  return {
    menuGroups: [],
    searchText: null,
    shouldShowModal: false,
    imagePath: null,
    shouldShowReferralModal: false,
    imageReferralPath: null,
    imgReferralLoading: true,
    imgLoading: true,
    isFirstVisit: false,
    referrer: '',
    noticeHeight: 0
  };
},
  watch: {
    shouldUseCustomHeader: {
      handler() {
        this.$nextTick(this.emitHeaderHeight);
      },
      immediate: true
    },
    // Switching menus on the same store (e.g. Lunch -> Dinner) reuses this component
    // instance -- Vue Router doesn't remount on a route with only :mid changing -- so
    // mounted()'s one-time fetchAiRecommendations dispatch never re-runs on its own,
    // leaving recommendations (and their menuCode-derived items) stuck on whichever
    // menu was viewed first.
    '$route.params.mid'(newMid, oldMid) {
      if (newMid !== oldMid) {
        this.$store.dispatch('fetchAiRecommendations')
      }
    },
    'getCheckoutInfo.scheduledDay': {
    handler(newVal) {
      if (newVal) {
        const targetDate = new Date(newVal);
        const now = new Date();
        if (targetDate < now) {
          this.$nextTick(() => {
            this.$store.commit('SET_CHECKOUT_INFO', {
              ...this.getCheckoutInfo,
              scheduledDay: now.toISOString()
            });
          });
        }
      }
      this.refilterCategories();
    },
    immediate: true 
  },
    'getCheckoutInfo.scheduledDay': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.refilterCategories();
        }
      },
      immediate: true 
    },
    'getCheckoutInfo.scheduledTime': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.refilterCategories();
        }
      },
      immediate: true 
    }
  },
  computed: {
    stickyMenuTop() {
      return 64;
    },
    stickyMenuOffset() {
      // offset (header) + reactive notice height (updated via observer)
      return this.stickyMenuTop + (this.noticeHeight || 0);
    },
    filteredCategories() {
      let availableCategories = [];
      let unAvailableCategories = [];
      let menuInSchedule = true;

      if (
        this.getMenu &&
        this.getMenu.schedule &&
        this.getMenu.schedule.items &&
        this.getCheckoutInfo &&
        this.getCheckoutInfo.scheduledDay &&
        this.getCheckoutInfo.scheduledTime
      ) {
        const scheduledDay = get(this.getCheckoutInfo, 'scheduledDay', null);
        const scheduledTime = get(this.getCheckoutInfo, 'scheduledTime', null);

        let targetDate;

        if (scheduledDay) {
          targetDate = new Date(scheduledDay);
          const now = new Date();

          if (scheduledTime) {
            if (scheduledTime === "now") {
              targetDate.setHours(now.getHours());
              targetDate.setMinutes(now.getMinutes());
              targetDate.setSeconds(now.getSeconds());
            } else if (!isNaN(Date.parse(scheduledTime))) {
              const parsedTime = new Date(scheduledTime);
              targetDate.setHours(parsedTime.getHours());
              targetDate.setMinutes(parsedTime.getMinutes());
              targetDate.setSeconds(parsedTime.getSeconds());
            } else {
              console.error(`Invalid scheduledTime format: ${scheduledTime}`);
              targetDate.setHours(0);
              targetDate.setMinutes(0);
              targetDate.setSeconds(0);
            }
          }
        } else {
          targetDate = new Date();
        }
        menuInSchedule = isInSchedule(this.getMenu.schedule.items, targetDate, 0);
      }

      if (this.getOrderType && this.getMenuItemsAndGroups) {
        for (let cat of this.getMenuItemsAndGroups) {
          if (!cat.hidden && this.validateItem(cat)) {
            const menuItems = cat.items.filter(
              item =>
                this.validateItem(item) &&
                this.passSearch(item) &&
                this.validateItemSchedule(item) &&
                menuInSchedule
            );
            menuItems.forEach(item => {
              item.schedule = item.schedule || cat.schedule || this.getMenu.schedule || [];
              item.advance = this.getHoursLimit;
            });

            if (menuItems.length) {
              const containsAvailableItem = !!menuItems.find(
                _item => !_item.outOfStock && this.validateScheduleItem(_item)
              );
              if (containsAvailableItem) {
                availableCategories.push({
                  code: cat.code,
                  name: cat.name,
                  description: cat.description,
                  anchor: generateMenuAnchorId(cat.code),
                  items: menuItems,
                  render: cat.render || false
                });
              } else {
                unAvailableCategories.push({
                  code: cat.code,
                  name: cat.name,
                  description: cat.description,
                  anchor: generateMenuAnchorId(cat.code),
                  items: menuItems,
                  render: cat.render || false
                });
              }
            }
          }
        }
      }
      if (availableCategories.length > 0) {
        return [...availableCategories];
      }
      if (this.searchText) {
        return [];
      }
      const hasScheduledDay = get(this.getCheckoutInfo, 'scheduledDay', null);
      if (hasScheduledDay) {
        return [];
      }
      if (this.getMenuItemsAndGroups) {
        return this.getMenuItemsAndGroups
          .filter(cat => !cat.hidden && this.validateItem(cat))
          .map(cat => ({
            code: cat.code,
            name: cat.name,
            description: cat.description,
            anchor: generateMenuAnchorId(cat.code),
            items: cat.items.map(item => ({
              ...item,
              disabled: true
            })),
            render: cat.render || false
          }));
      }

      return [];
    },

    menuDisclaimer() {
      const storeTranslations = get(this.getStore, 'settings.owaSettings.menuDisclaimer.translations', [])
      const groupTranslations = get(this.getGroup, 'settings.owaSettings.menuDisclaimer.translations', [])
      const translations = storeTranslations.length ? storeTranslations : groupTranslations
      return matchTranslation(translations) || null
    },

    ...mapGetters([
      'shouldUseCustomHeader',
      'getGroup',
      'getCheckoutInfo',
      'getCustomer',
      'getStore',
      'getMenu',
      'isMenuChannelAllowed',
      'getMenuItemsAndGroups',
      'getOrderType',
      'isDineIn',
      'getHoursLimit',
      'isStoreLoading',
      'getStoreSchedule',
      'isLoggedIn',
      'getAiRecommendationsCategory'
    ]),
    // Prepended ahead of real categories so it's the first thing guests see —
    // kept separate from filteredCategories itself since that computed has
    // several early-return branches (search/scheduled-day/all-unavailable)
    // this synthetic category should show through regardless of.
    //
    // getAiRecommendationsCategory's items carry the real item's own `name` already (a
    // plain string, not a translations array -- same as every other real menu item), but
    // still carry raw aiTagTranslations/aiReasonTranslations arrays (the getter itself
    // can't resolve those -- Vuex getters aren't reactive to $vuetify.lang.current, only
    // to Vuex state, so a resolved string would go stale on a language switch). Resolve
    // those two here instead, in this computed, so switching languages re-runs it and the
    // cards/dialog re-render with the new text.
    categoriesWithAiRecommendations() {
      if (!this.getAiRecommendationsCategory) return this.filteredCategories
      // Defense in depth: the AI service is asked to scope recommendations to the menu
      // currently being viewed (menu_code in the request), but fetchAiRecommendations
      // fires async and can still land after the guest has switched menus, or the
      // backend response can otherwise include items from a different menu (e.g. a
      // "menu_X_COPY_menu_Y" duplicate menu sharing item codes with menu_X). Never show
      // a recommendation for a menu other than the one on screen right now, regardless
      // of what the backend returns -- $route.params.mid, not getMenu, since getMenu
      // isn't reliably synced to the route on a same-store menu switch either.
      const currentMid = this.$route.params.mid
      const itemsForCurrentMenu = this.getAiRecommendationsCategory.items.filter(
        item => item.menuCode === currentMid
      )
      if (!itemsForCurrentMenu.length) return this.filteredCategories
      const resolvedCategory = {
        ...this.getAiRecommendationsCategory,
        items: itemsForCurrentMenu.map(item => ({
          ...item,
          aiTag: matchTranslation(item.aiTagTranslations) || '',
          aiReason: matchTranslation(item.aiReasonTranslations) || ''
        }))
      }
      return [resolvedCategory, ...this.filteredCategories]
    }
  },

  methods: {
    initNoticeHeightWatcher() {
      const updateHeight = () => {
        const el = document.getElementById('storeNoticeAlert');
        this.noticeHeight = el ? el.offsetHeight : 0;
      };
      this.$nextTick(() => {
        updateHeight();
        const el = document.getElementById('storeNoticeAlert');
        if (el && 'ResizeObserver' in window) {
          this._noticeResizeObserver = new ResizeObserver(() => updateHeight());
          this._noticeResizeObserver.observe(el);
        }
        window.addEventListener('resize', updateHeight, { passive: true });
        this._noticeResizeCleanup = () => {
          window.removeEventListener('resize', updateHeight);
          if (this._noticeResizeObserver) {
            this._noticeResizeObserver.disconnect();
            this._noticeResizeObserver = null;
          }
        };
      });
    },
    refilterCategories() {
      this.$forceUpdate();
    },
    clearSearch() {
      if (this.$refs.MenuCategory && this.$refs.MenuCategory.hideSearch) {
        this.$refs.MenuCategory.hideSearch()
      } else if (this.$refs.MenuCategoryCustom && this.$refs.MenuCategoryCustom.hideSearch) {
        this.$refs.MenuCategoryCustom.hideSearch()
      }
      this.searchText = null
    },
    validateItemSchedule(item) {
      const targetDate = buildScheduledTargetDate(this.getCheckoutInfo);
      const scheduleItems = getItemScheduleItems(item, targetDate);
      if (!scheduleItems.length) {
        return true;
      }

      const scheduledDay = get(this.getCheckoutInfo, 'scheduledDay', null);
      // When the user has selected a specific scheduled day/time, use advance=0.
      // Advance hours are for "is this orderable now or soon?" — not for a user-chosen future time.
      const advance = scheduledDay ? 0 : (item.advance || 0);
      return isInSchedule(scheduleItems, targetDate, advance);
    },
    scrollToMenu() {
      const menuText = document.getElementById('menuText')
      if (menuText) {
        const menuPosition = menuText.getBoundingClientRect().top
        const viewportHeight = window.innerHeight
        if (menuPosition > viewportHeight * 0.3 && menuPosition < viewportHeight) {
          menuText.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }
      }
    },
    scrollToElement(elementId) {
      const catParam = this.$route.query.cat || null
      const resolvedId = resolveMenuItemId(elementId, catParam, this.filteredCategories)
      this.$nextTick(() => {
        const attemptScroll = (attempt = 0) => {
          const element = document.getElementById(resolvedId);
          if (element) {
            this.performScroll(element);
          } else {
            let needsRendering = false;
            this.filteredCategories.forEach((category, index) => {
              if (!category.render && index !== 0) {
                this.$set(this.filteredCategories[index], 'render', true);
                needsRendering = true;
              }
            });
            
            if (needsRendering) {
              this.$forceUpdate();
              setTimeout(() => {
                const renderedElement = document.getElementById(resolvedId);
                if (renderedElement) {
                  this.performScroll(renderedElement);
                } else if (attempt < 3) {
                  setTimeout(() => attemptScroll(attempt + 1), 500);
                }
              }, 800);
              return;
            }
            
            if (attempt < 5) {
              setTimeout(() => attemptScroll(attempt + 1), 300 * (attempt + 1));
            } else {
              const allElements = document.querySelectorAll('[id]');
            }
          }
        };
        
        attemptScroll();
      });
    },
    // Height covered by the header, store notice and stuck category bar
    stickyScrollOffset() {
      const stickyEl = document.querySelector('.sticky');
      return this.stickyMenuOffset + (stickyEl ? stickyEl.offsetHeight : 0);
    },
    performScroll(element) {
      const stickyOffset = this.stickyScrollOffset() + 8;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - stickyOffset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      
      this.highlightElement(element);
    },
    findParentCategoryContainer(element) {
      let current = element;
      while (current && !current.classList.contains('menuContainer')) {
        current = current.parentElement;
      }
      return current;
    },
    
    highlightElement(element) {
      element.classList.add('highlight-item');
      setTimeout(() => {
        element.classList.remove('highlight-item');
      }, 1500);
    },
  
    extractReferrer() {
      const urlParams = new URLSearchParams(window.location.search);
      this.referrer = urlParams.get('referrer') || '';
    },
    imagePth() {
      const store = this.getStore;
      let path;
      if (store &&
      store.settings &&
      store.settings.owaSettings &&
      store.settings.owaSettings.owaStoreNews && 
      store.settings.owaSettings.owaStoreNews.news && 
      store.settings.owaSettings.owaStoreNews.news.length
      ) {
        path = `${process.env.VUE_APP_API_IMAGE}${store.settings.owaSettings.owaStoreNews.news[0].imgUrl}`
        const forcePopup = JSON.parse(localStorage.getItem('forcePopup'));
        this.shouldShowModal = this.isFirstVisit || forcePopup;
        if (localStorage.getItem('forcePopup')) {
          localStorage.removeItem('forcePopup');
        }
      }
      this.imagePath = path
    },
    imageReferralPth() {
      const store = this.getStore;
      const referrerPath = this.$route.query.referrer;
      let path;
      if (store &&
      store.settings &&
      store.settings.rewardsSettings &&
      store.settings.rewardsSettings.referralSettings &&
      store.settings.rewardsSettings.referralSettings.referralBannerImageUrl &&
      store.settings.rewardsSettings.supportsReferralBonus &&
      referrerPath
      ) {
        path = `${process.env.VUE_APP_API_IMAGE}${store.settings.rewardsSettings.referralSettings.referralBannerImageUrl}`
        const forcePopupReferral = JSON.parse(localStorage.getItem('forcePopupReferral'));
        this.shouldShowReferralModal = this.isFirstVisit || forcePopupReferral;
        if (localStorage.getItem('forcePopupReferral')) {
          localStorage.removeItem('forcePopupReferral');
        }
      }
      this.imageReferralPath = path
    },
    validateScheduleItem(menuItem) {
      const scheduleDetails = [
        {
          schedule: this.getStoreSchedule,
          advance: this.getHoursLimit
        }, {
          schedule: getItemScheduleItems(menuItem, buildScheduledTargetDate(this.getCheckoutInfo)),
          advance: get(menuItem, 'advance', 0)
        }
      ]

      return compareSchedules(scheduleDetails, buildScheduledTargetDate(this.getCheckoutInfo), this.getStore.timezone || null)
    },
    validateItem(menuItem) {
      if (menuItem.saleType) {
        if (menuItem.saleType == 'ALL')
          return true

        if (menuItem.saleType == 'DINE_IN')
          return this.getOrderType == 'DINE_IN'

        if (menuItem.saleType == 'DELIVERY')
          return this.getOrderType == 'DELIVERY'

        if (menuItem.saleType == 'PICKUP')
          return this.getOrderType == 'PICKUP'

        if (menuItem.saleType == 'TAKE_OUT')
          return this.getOrderType == 'DELIVERY' || this.getOrderType == 'PICKUP'

        if (menuItem.saleType == 'DELIVERY_DINE_IN')
          return this.getOrderType == 'DELIVERY' || this.getOrderType == 'DINE_IN'

        if (menuItem.saleType == 'PICKUP_DINE_IN')
          return this.getOrderType == 'PICKUP' || this.getOrderType == 'DINE_IN'

        console.warn('Failed to match saleType', menuItem.saleType);
      }

      return true
    },

    passSearch(item) {
      const q = (this.searchText || '').trim()
      return !q ||
        item.name.toLowerCase().includes(q.toLowerCase()) ||
        (item.description && item.description.toLowerCase().includes(q.toLowerCase())) ||
        (item.shortName && item.shortName.toLowerCase().includes(q.toLowerCase()))
    },

    showAsList(category) {
      const _displayMode = get(this.getStore, 'settings.owaSettings.menuDisplayMode')

      if (_displayMode === 'LIST') {
        return true;
      } else if (_displayMode === 'CARD') {
        return false;
      } else {
        return category.menuDisplayMode !== 'CARD';
      }
    },

    ...mapActions([ 'fetchShoppingCart', 'setTableId', 'setOrderType', 'setExistingOrder', 'fetchAllCoupons', 'fetchOptions', 'fetchThumbsUpHistory', 'fetchPromotions' ])
  },

  async mounted() {
    if (this.isLoggedIn) {
      this.fetchThumbsUpHistory();
    }
   EventBus.$on('scrollToMenu', this.scrollToMenu)
    await this.fetchOptions()
    this.fetchPromotions()
    this.$store.dispatch('fetchAiRecommendations')

    if (this.isLoggedIn) {
      await this.setExistingOrder()
    } else {
      this.fetchAllCoupons()
    }

    this.extractReferrer()
    if (this.referrer && this.referrer.length) {
      this.$api.post('/guest/referrer', {
        referrerCustomerId: this.referrer
      })
      .then(response => console.log(response))
      .catch(error => console.error('Error:', error));
    }
    const store = this.getStore
    if (store) {
      const tid = this.$route.query.tid;
      if (tid) {
        this.$store.dispatch("setTableId", tid);
        this.$store.dispatch("setOrderType", "DINE_IN");
      } else {
        this.$store.commit("CLEAR_TABLE_ID");
        // Landing here with no tid means this isn't a dine-in visit -- but orderType
        // and any shared-cart session are separate state that CLEAR_TABLE_ID alone
        // doesn't touch, so a guest arriving straight from a shared-cart table (no
        // "Table Paid" dialog dismissal, e.g. typing/bookmarking this URL directly)
        // stayed stuck in DINE_IN mode with a stale shared-cart session still active.
        if (this.$store.getters['sharedCart/isActive']) {
          this.$store.dispatch('sharedCart/clearSharedCart')
        }
        if (this.$store.getters.getOrderType === 'DINE_IN') {
          const storeOrderTypes = this.$store.getters.getStoreOrderTypes || [];
          const pickupType = storeOrderTypes.find((type) => type.value === 'PICKUP');
          const nextType = pickupType || storeOrderTypes[0];
          if (nextType) {
            this.$store.dispatch('setOrderType', nextType.value);
          }
        }
      }
      const dineInOnlyQueryParam = this.$route.query.dineInOnly;
      if (dineInOnlyQueryParam) {
        this.$store.dispatch("setOrderType", "DINE_IN");
      }
    }
    const itemId = this.$route.query.id;
    const catParam = this.$route.query.cat;
    const shouldOpen = this.$route.query.open === 'true';
    if (itemId) {
      setTimeout(() => {
        this.scrollToElement(itemId);
      }, 700);
      if (shouldOpen) {
        _autoOpenFired = false
        const tryClick = () => {
          if (_autoOpenFired) return
          const resolvedCode = resolveMenuItemId(itemId, catParam || null, this.filteredCategories)
          const el = document.getElementById(resolvedCode)
          const cardVm = el && el.__vue__
          if (cardVm && typeof cardVm.handleOrderItem === 'function') {
            _autoOpenFired = true
            cardVm.handleOrderItem()
          } else {
            setTimeout(tryClick, 200)
          }
        }
        setTimeout(tryClick, 300)
      }
    } else if (catParam) {
      setTimeout(() => {
        const category = this.filteredCategories.find(
          c => slugifyMenuItemName(c.name) === catParam
        );
        if (category) this.scrollToElement(category.anchor);
      }, 700);
    }

    // Dynamic notice height tracking for sticky offset
    this.initNoticeHeightWatcher();
  },

  beforeRouteEnter(to, from, next) {
    const isFirstVisit = from.name === null;
    next(vm => {
      vm.isFirstVisit = isFirstVisit;
      vm.imagePth();
      vm.imageReferralPth();
    });
  },

  beforeRouteLeave(to, from, next) {
    const scrollTop = document.getElementsByTagName("body")[0].scrollTop || document.getElementsByTagName("html")[0].scrollTop || document.getElementById("app").scrollTop

    // Block the back button when menu item config is open, instead just close
    if (!!this.$store.state.menuItemDialog) {
      next(false)

      // I'm a hack
      // If you try to scroll back to position as you deny the back button in StorePage.vue, it scrolls to the top
      // So we have to wait for the default scroll to top to start, then we do our own to go back to where they were
      setTimeout(() => {
        enableDocumentScrolling(this.scrollTop)
        this.scrollTop = null
      }, 50)
    } else {
      next()
    }
  },
  beforeDestroy() {
    if (this._noticeResizeCleanup) {
      this._noticeResizeCleanup();
    }
  }
}
</script>

<style scoped>
  ::v-deep .highlight-item {
    animation: highlight-pulse 1s ease-in-out;
    box-shadow: 0 0 15px 5px var(--v-primary-base, 0.5);
    z-index: 1;
  }
  
  @keyframes highlight-pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.03); }
    100% { transform: scale(1); }
  }
  .subheader {
    color: black !important;
    font-size: 1.4rem;
    font-weight: 700;
    margin-top: 10px;
    padding: 0px !important;

    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;
    line-clamp: 3;
    -webkit-line-clamp: 3;
    line-clamp: 3;

    height: auto !important;
    text-transform: uppercase;
  }
  .categoryDescription {
    position: relative;
    left: 5px;

    font-size: var(--text-size-1);
    text-align: left;
  }

  .menu-disclaimer {
    text-align: center;
    font-size: var(--text-size-1);
    color: #555;
    padding: 16px 24px 32px;
    margin: 0;
  }

  .sticky-parent {
    position: relative;
    padding-bottom: 50px;
  }
  
  @media (min-width: 768px) {
    .marginsDesktop {
      margin-left: 19.25px;
      margin-right: 19.25px;
    }
  }

  .sticky {
    position: -webkit-sticky;
    position: sticky;
    z-index: 2;
  }

  #NoResultsFound {
    margin: 0px auto 75px;

    height: calc(100vh - 175px);
  }
  #menuText {
    /* margin-top: 20px; */
    height: 48px;
    width: 100vw;
    background-color: #F5F5F5;
    text-align: left;
    line-height: calc(var(--text-size-2) + 5px);
    padding: 15px 18px;
  }
  #menuText {
    font-size: calc(var(--text-size-2) * 0.85) !important;
    font-weight: bold;
  }
  @media only screen and (max-width: 920px) {
    #menuText {
      font-size: var(--text-size-1);
      line-height: calc(var(--text-size-1) + 5px);
    }
    .menuContainer {
      margin-left: 18px;
      margin-right: 18px;
    }
    .subheader {
      color: black !important;
      font-size: calc(var(--text-size-2) * 0.85) !important;
      font-weight: 700;
      margin-top: 10px;
    }
  }
  ::v-deep .vertical-card {
    flex: 0 0 auto !important;
  }
  .custom-header.categoryDescription {
    font-size: 23px !important;
    text-align: center !important;
  }

  .custom-header.subheader {
    font-size: 50px !important;
    text-align: center !important;
  }

  .menuHeader {
    width: 100%;
    display:flex;
    justify-content: center;
    background-color: #012D61;
    margin-top: 60px;
  }
  .menuHeaderText {
    font-size: 23px;
    font-weight: bold;
    text-align: center;
    margin: 0 auto;
    padding: 10px 0;
    width: 100%;
    color: white;
  }
  @media (max-width: 600px) {
    .menuHeaderText {
      font-size: 18px !important;
      width: auto !important;
      max-width: 90vw;
      display: inline-block;
    }
    .menuHeader {
      justify-content: center;
      margin-top: 30px;
    }
  }
</style>
